// CompareSheet — French. 'Close' and 'Loading…' live in common.fr.ts. 'not scored' and the
// ProfileZone evidence sentence are declared below rather than borrowed, so this sheet reads
// French on its own; the values are byte-identical to the other declarations.
import { registerFr } from '../i18n/index.js';

registerFr({
  'The comparison did not answer': 'La comparaison n’a pas répondu',
  'Pick two organisations in the grid to compare their rasters.':
    'Choisissez deux organisations dans la grille pour comparer leurs profils.',
  'cells differ where both are collected': 'cellules diffèrent là où les deux côtés sont relevés',
  'on one side only': 'relevées d’un seul côté',
  'Only what differs': 'Seulement les différences',
  'Show every cell': 'Afficher toutes les cellules',
  'Nothing differs between these two — every cell either matches or is uncollected on both sides.':
    'Rien ne diffère entre les deux — chaque cellule concorde ou n’est relevée d’aucun côté.',
  'cells': 'cellules',
  'Neither side keeps a verbatim passage for this cell.':
    'Aucun des deux côtés ne conserve de passage verbatim pour cette cellule.',
  'Show the verbatim evidence for this value': 'Afficher la preuve verbatim de cette valeur',
  'The evidence names a source but keeps no verbatim passage.':
    'La preuve nomme une source mais ne conserve aucun passage verbatim.',
  'not scored': 'non noté',
}, 'CompareSheet');
